import { createContext, useContext } from "react";

interface DevtoolsContextProps {
  isDevtoolsOpen: boolean;
  toggleDevtools: () => void;
}

export const DevtoolsContext = createContext<DevtoolsContextProps | undefined>(undefined);

export const useDevtools = (): DevtoolsContextProps => {
  const context = useContext(DevtoolsContext);
  if (!context) {
    throw new Error("useDevtools must be used within a DevtoolsProvider");
  }
  return context;
};
